import { apiClient } from './client';
import type { Order } from '../types';

interface AdminOrdersResponse {
  orders: Order[];
  total: number;
  limit: number;
  offset: number;
}

interface AdminOrdersParams {
  status?: string | string[];
  search?: string;
  limit?: number;
  offset?: number;
}

interface UpdateStatusParams {
  status: string;
  comment?: string;
}

interface UpdatePaymentParams {
  payment_method: string;
}

export const adminOrdersApi = {
  // Get all orders with filters
  getOrders: (params?: AdminOrdersParams) => {
    const queryParams = new URLSearchParams();

    if (params?.status) {
      if (Array.isArray(params.status)) {
        params.status.forEach(s => queryParams.append('status', s));
      } else {
        queryParams.append('status', params.status);
      }
    }

    if (params?.search) {
      queryParams.append('search', params.search);
    }

    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    if (params?.offset) {
      queryParams.append('offset', params.offset.toString());
    }

    const query = queryParams.toString();
    return apiClient.get<AdminOrdersResponse>(`/admin/orders${query ? `?${query}` : ''}`);
  },

  // Get single order details
  getOrder: (id: number) => apiClient.get<Order>(`/admin/orders/${id}`),

  // Update order status
  updateStatus: (id: number, params: UpdateStatusParams) =>
    apiClient.patch<{ message: string }>(`/admin/orders/${id}/status`, params),

  // Update payment method
  updatePayment: (id: number, params: UpdatePaymentParams) =>
    apiClient.patch<{ message: string }>(`/admin/orders/${id}/payment`, params),
};
